import About from '@/pages/About/About';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';
import OrganizationSchema from '@/v2/domains/SEO/components/Schemas/OrganizationSchema';

export default function AboutPage() {
  return (
    <>
      <PageMetadata title="About us - Meet the Rockalingua Team">
        <OrganizationSchema />
      </PageMetadata>
      <About />
    </>
  );
}
